export const JOB_CLASSIFICATION_TEMPLATE_PATH = "/static/Job_classification_template.xlsx";
